import {
  commons,
  commonsOtherDocs2,
  concession,
  concessionLetterRequired,
  decision,
  otherDocs3,
  others,
  revisedDocsCommons,
} from '../constants';
import { initialValuesGenerator } from '../initialValueGenerator';
import { dynamicRule } from '../rules';

export const CPADocs = () => {
  const rules = {
    anexoOutros: dynamicRule(),
    anexoRG: dynamicRule('required'),
    anexoCPF: dynamicRule('required'),

    anexoDecisao: dynamicRule(),
    anexoSB40Etc: dynamicRule('aposentado&processo'),

    anexoCTPS: dynamicRule('required'),
    anexoCertReservista: dynamicRule(),

    anexoCarta: dynamicRule('aposentado'),
    anexoCienciaConcessao: dynamicRule('tutela'),
    anexoSentecaJudicial: dynamicRule('processoJudicial'),
    anexoTutelaCPA: dynamicRule('tutela'),
    anexoMovimentacaoProcessualAtualizada: dynamicRule('processoJudicial'),
    anexoJulgadoCPA: dynamicRule('transitoEmJulgado'),
  };

  const docs = {
    commons: [...commons, ...otherDocs3, ...commonsOtherDocs2, ...others],
    admin: [...concessionLetterRequired],
    tutela: [
      ...concessionLetterRequired,
      ...concession,
      ...revisedDocsCommons,
      {
        name: 'anexoTutelaCPA',
        label:
          'Certidão de objeto e pé ou inteiro teor* OU Decisões de Liminares ou de Mérito do Processo*',
      },
    ],
    julgado: [
      ...concessionLetterRequired,
      ...revisedDocsCommons,
      {
        name: 'anexoJulgadoCPA',
        label:
          'Certidão de objeto e pé ou inteiro teor* OU Decisões de Liminares ou de Mérito do Processo* OU Certidão de Transitou em Julgado*',
      },
    ],
    naoAposentado: [...decision], // = commons
  };

  const initialValues = initialValuesGenerator(docs);

  return {
    initialValues,
    rules,
    docs,
  };
};
